import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { Navbar } from "../styled/nav-bar";

export const StudoqTestPage = () => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      spacing={4}
      pt={2}
      pl={2}
      pr={2}
      pb={5}
    >
      <Navbar />

      <Grid
        container
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignContent="center"
      >
        <Grid item>
          <Typography variant="h5" mt={4} py={4} fontWeight="bold">
            StuDoQ Tests
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8} width="100%">
          <Paper>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: "16px", fontWeight: "bold" }}>
                      Formular Nr.
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Formularname
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Aktion
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={""}>
                    <TableCell>1</TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                      }}
                    >
                      StuDoQ | Erstvorstellung + Stammdaten
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                      }}
                    >
                      <button>Öffnen</button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};
